

(function restUrlBuilderServiceDefinition() {

    'use strict';

    /*
    Este servicio permite armar Urls y abstraerse de $http. 
    Es similar a la funcionalidad de restangular con la excepcion de que no se "Restangularizan" los objetos,
    sino que solo se generan las urls y se encapsula la invocación de $http.
    La forma de uso puede ser:
        restUrlBuilder.one()... para usar el default API endpoint
        restUrlBuilder('APIEndpointKey').one()... para especificar el endpoint a utilizar.
    */
    angular.module('RESTUrlBuilder')
        .provider('restUrlBuilder', [
            function restUrlBuilderProvider() {
                                
                this.$get = ['config', '$http', '$q', 
                    function restUrlBuilderService(config, $http, $q) {

                        function resolvePromise(promise) {

                            var deferred = $q.defer();

                            promise.then(function success(response) {
                                if (response.status === 200 || response.status === 201) {
                                    deferred.resolve(response.data);
                                } else {
                                    deferred.reject({
                                        data: response.data,
                                        status: response.status,
                                        headers: response.headers,
                                        config: response.config
                                    });
                                }
                            }, function (response) {

                                var error = {
                                    status: response.status,
                                    data: response.data,
                                    headers: response.headers,
                                    config: response.config
                                };

                                if ((response.status === 409 || response.status === 400 || response.status === 406) && response.data) {
                                    if (typeof (response.data) === 'string') {
                                        error.code = response.data;
                                    }
                                }

                                deferred.reject(error);
                            });

                            return deferred.promise;
                        }

                        function restUrlBuilder(url, baseUrl) {
                            this.url = url;
                            this.baseUrl = baseUrl || url;
                        };

                        restUrlBuilder.prototype.baseUrl = function baseUrl() {
                            return this.baseUrl;
                        };

                        restUrlBuilder.prototype.one = function one(resourceName, id) {
                            return new restUrlBuilder(this.url + '/' + resourceName + '/' + id, this.url);
                        };

                        restUrlBuilder.prototype.all = function all(resourceName) {
                            return new restUrlBuilder(this.url + '/' + resourceName, this.url);
                        };

                        restUrlBuilder.prototype.custom = function custom(methodName) {
                            return new restUrlBuilder(this.url + '/' + methodName, this.url);
                        };

                        /* Metodos HTTP */
                        restUrlBuilder.prototype.get = function get(config) {
                            return resolvePromise($http.get(this.url, config));
                        };

                        restUrlBuilder.prototype.delete = function del(config) {
                            return resolvePromise($http.delete(this.url, config));
                        };

                        restUrlBuilder.prototype.post = function post(elem, config) {
                            return resolvePromise($http.post(this.url, elem, config));
                        };

                        restUrlBuilder.prototype.put = function put(elem, config) {
                            return resolvePromise($http.put(this.url, elem, config));
                        };

                        restUrlBuilder.prototype.patch = function patch(changes, config) {
                            return resolvePromise($http.patch(this.url, changes, config));
                        };

                        restUrlBuilder.prototype.create = restUrlBuilder.prototype.post;
                        restUrlBuilder.prototype.save = restUrlBuilder.prototype.put;

                        restUrlBuilder.prototype.getUrl = function getUrl(params) {

                            if (params) {
                                var query = '';

                                angular.forEach(params, function (value, key) {
                                    query += key + '=' + value;
                                });

                                if (query)
                                    return this.url + '?' + query;
                            }
                            return this.url;
                        };

                        var restUrlServiceFactory = function (apiEndpointKey) {
                            return new restUrlBuilder(config.apiUrl('', apiEndpointKey));
                        }

                        restUrlServiceFactory.one = function one(resourceName, id) {
                            return new restUrlBuilder(config.apiUrl('/' + resourceName + '/' + id));
                        };
                        
                        restUrlServiceFactory.all = function all(resourceName) {
                            return new restUrlBuilder(config.apiUrl('/' + resourceName));
                        };

                        restUrlServiceFactory.builderForUrl = function createBuilder(urlBase) {
                            return new restUrlBuilder(urlBase);
                        };

                        restUrlServiceFactory.baseUrl = function() {
                            return config.apiUrl('/');
                        };

                        restUrlServiceFactory.diff = function (baseLine, elem) {

                            var count = 0;

                            angular.forEach(baseLine, function baselineCompare(value, key) {
                                if (key !== 'id' && angular.equals(baseLine[key], elem[key]))
                                    delete elem[key];
                                else if (key !== 'id')
                                    count++;
                            });

                            // por si quedaron propiedades en elem que no estaban en baseLine
                            angular.forEach(elem, function baselineCompare(value, key) {
                                if (!baseLine.hasOwnProperty(key))
                                    count++;
                            });

                            return count !== 0;
                        };

                        return restUrlServiceFactory;
                    }
                ];
            }
        ]);

})();